import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DarkSectionComponent } from '../dark-section';

/** One FAQ entry rendered as a definition-list item; both fields are i18n keys. */
export interface FaqSectionItem {
  questionKey: string;
  answerKey: string;
}

/**
 * Dark FAQ section shared by the home and tool pages:
 * a titled definition list of translated question/answer pairs.
 */
@Component({
  selector: 'lib-faq-section',
  imports: [TranslateModule, DarkSectionComponent],
  templateUrl: './faq-section.component.html',
  styleUrl: './faq-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FaqSectionComponent {
  readonly titleKey = input.required<string>();
  /** Id of the section heading, referenced by aria-labelledby. */
  readonly headingId = input.required<string>();
  readonly items = input.required<FaqSectionItem[]>();
}
